import { createSelector } from 'reselect'

import { IOnboardingState } from '../models'

export const selectParentRequestData = (state: { onboarding: IOnboardingState }) =>
  state.onboarding.parentRequestData

export const selectParentRequestLoadingStatus = createSelector(
  [selectParentRequestData],
  ({ status }) => status
)
